import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "app-assignment"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务时间", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "状态", -1);

const _hoisted_7 = {
  class: "wrapper"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务类型", -1);

const _hoisted_9 = {
  class: "wrapper"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "任务名称", -1);

const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_13 = /*#__PURE__*/_createTextVNode("新增任务");

const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  key: 1
};
const _hoisted_16 = {
  key: 2
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("作废");

const _hoisted_18 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 详情/进度 ");

import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import { ElMessageBox, ElMessage } from 'element-plus';
import axios from '@/request/createAxiosInstalce';
import { taskList, taskCancel } from '@/request';
export default {
  name: 'index',

  setup(__props) {
    const router = useRouter();
    const search = reactive({
      dateRange: [],
      status: '',
      name: ''
    });
    const taskType = ref('');
    const statusList = [{
      name: '全部',
      value: ''
    }, {
      name: '待开始',
      value: '0',
      color: '#E6A23C'
    }, {
      name: '进行中',
      value: '1',
      color: '#67C23A'
    }, {
      name: '已结束',
      value: '2',
      color: '#73767a'
    }, {
      name: '已作废',
      value: '3',
      color: '#b1b3b8'
    }];
    const taskTypeText = {
      '1': '拜访任务',
      '2': '陈列任务',
      '3': '会议邀约任务',
      '4': '培训学习',
      '5': '培训考试'
    };
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '任务类型',
        field: 'taskType',
        width: 100,
        slots: {
          default: 'taskType'
        }
      }, {
        title: '任务名称',
        field: 'taskName'
      }, {
        title: '任务时间',
        field: 'startTime',
        // width: 180,
        slots: {
          default: 'time'
        }
      }, {
        title: '任务要求/课程',
        field: 'custNum',
        slots: {
          default: 'custNum'
        }
      }, {
        title: '任务成员（人数）',
        field: 'userCount',
        width: 100
      }, {
        title: '任务奖励',
        field: 'rewardDesc',
        slots: {
          default: 'rewardDesc'
        }
      }, {
        title: '最近修改时间',
        field: 'updateAt',
        width: 180
      }, {
        title: '状态',
        field: 'status',
        width: 100,
        slots: {
          default: 'status'
        }
      }, {
        title: '操作',
        slots: {
          default: 'operation'
        },
        width: 200
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            let start = search.dateRange[0];
            let end = search.dateRange[1];
            let params = {
              page: page.currentPage,
              pageSize: page.pageSize,
              taskType: taskType.value,
              startTime: start ? `${start} 00:00:00` : undefined,
              endTime: end ? `${end} 23:59:59` : undefined,
              status: search.status,
              taskName: search.name
            };
            taskList(params).then(data => {
              res({
                total: data.total,
                result: data.data
              });
            });
          })
        }
      }
    });

    function reset() {
      search.dateRange = [];
      search.status = '';
      search.name = '';
      taskType.value = '';
      table.value.commitProxy('reload');
    }

    function destroyHandle(taskId) {
      ElMessageBox.confirm('作废后，将通知团队成员，任务将无法继续执行，确认是否作废?', '提示', {
        type: 'warning'
      }).then(() => {
        axios.post(`/admin/task/cancel?taskId=${taskId}`).then(res => {
          let {
            success,
            msg
          } = res.data;

          if (success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          } else {
            ElMessage.error(msg);
          }
        });
      });
    }

    function formatTime(time) {
      return time.split(' ')[0];
    }

    function formatStatus(status) {
      return statusList.find(item => item.value == status);
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_date_picker, {
        modelValue: search.dateRange,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.dateRange = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: search.status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.status = $event)
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, item => {
          return _createVNode(_component_el_option, {
            value: item.value,
            label: item.name,
            key: item.value
          }, null, 8, ["value", "label"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: taskType.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => taskType.value = $event),
        placeholder: "请选择任务类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "拜访任务",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "陈列任务",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "会议邀约任务",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "培训学习",
          value: "4"
        }), _createVNode(_component_el_option, {
          label: "培训考试",
          value: "5"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_el_input, {
        modelValue: search.name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.name = $event),
        placeholder: "请输入任务名称"
      }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => _unref(router).push({
          name: 'assignmentUpdate'
        }))
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        taskType: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(taskTypeText[row.taskType]), 1)]),
        time: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.startTime + '~' + row.endTime), 1)]),
        custNum: _withCtx(({
          row
        }) => [row.taskType == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.trainingCourseName || '-'), 1)) : row.taskType == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(row.trainingPaperName || '-'), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(`客户数: ${row.custNum}个`), 1))]),
        rewardDesc: _withCtx(({
          row
        }) => [_createElementVNode("span", null, _toDisplayString(row.rewardDesc || '无'), 1)]),
        status: _withCtx(({
          row
        }) => [_createElementVNode("span", {
          style: _normalizeStyle(`color:${formatStatus(row.status)['color']}`)
        }, _toDisplayString(formatStatus(row.status)['name']), 5)]),
        operation: _withCtx(({
          row
        }) => [row.status == '0' || row.status == '1' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          link: "",
          onClick: $event => destroyHandle(row.taskId)
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.status == '0' || row.status == '1' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          link: "",
          onClick: $event => _unref(router).push({
            name: 'assignmentUpdate',
            query: {
              taskId: row.taskId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "primary",
          link: "",
          onClick: $event => _unref(router).push({
            name: 'assignmentDetail',
            query: {
              taskId: row.taskId
            }
          })
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16)]);
    };
  }

};